// Define field names here as variables

export const EMAIL = 'email';
export const VOORNAAM = 'given_name';
export const ACHTERNAAM = 'family_name';

export const GENDER = 'gender';
export const GENDER_MAN = 'm';
export const GENDER_VROUW = 'f';
export const GENDER_NEUTRAAL = 'u';
export const GENDER_GEEN = ' ';

export const BIRTHDATE = 'birthdate';
export const PICTURE = 'picture';

export const STRAAT = 'address.street_address';
export const POSTCODE = 'address.postal_code';
export const WOONPLAATS = 'address.locality';
export const POSTCODE_WOONPLAATS = 'postalcode_locality';
export const LAND = 'address.country';

export const PHONE = 'phone_number';
export const PHONE_VERIFICATION = 'phone-verification';
export const PHONE_VERIFICATION_CODE = 'phone_verification_code';
export const PHONE_COUNTRY_CODE = 'phone_country_code';

export const PASSWORD = 'password';
export const PASSWORD_CREATION = 'password_creation';

export const MARKETING_ID = 'marketing_id';

// Device
export const HUMAN_READABLE_DEVICE_NAME = 'human_readable_device_name';

// Subprofile
export const LOGIN_CODE = 'login_code';
export const SUB = 'sub';
export const AVATAR_ID = 'avatar_id';
export const AVATARS = 'avatars';
export const SUBPROFILES = 'sub_profiles';
export const SHOW_CREATE_SUBPROFILE = 'show_create_sub_profile';
export const SHOW_KETNET_NEWSLETTER = 'show_ketnet_newsletter';
export const INTERACTION = 'interaction';
export const INTERACTION_REVIEWED_ON = 'interaction_reviewed_on';
export const VOORNAAM_OUDER = 'given_name_parent';
export const KETNET_NEWSLETTER_OPTIN = 'ketnet_newsletter_optin';

export const REDIRECT_URI = 'redirect_uri';

// Wildcards
export const WILDCARD = 'wildcard';
export const WILDCARD_REQUIRED = 'wildcard_required';
export const WILDCARD_BOOLEAN = 'wildcard_boolean';
export const WILDCARD_BOOLEAN_REQUIRED = 'wildcard_boolean_required';

// General Keynames
export const CLIENT_ID = 'client_id';
export const ID_TOKEN_HINT = 'id_token_hint';

export const TOS_CONSENT_CODE = 'vrt-tos';
export const COMMERCIAL_CONSENT_CODE = 'vrt-commercial';
export const PROVIDER_CONSENT_CODE = 'vrt-provider';

export const CSRF_COOKIE_NAME = 'OIDCXSRF';
export const LOGIN_HINT = 'loginHint';
export const CANCEL_SUPPORTED = 'cancelSupported';
export let MASKED_CODE = 'maskedCode';
